import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import classNames from "classnames";
import { globalEventsHandler } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { useLoyalty } from "@jti/ui/hooks/useLoyalty";
import "./style.scss";
const PointsDisplay = ({ currency, isStyledNumber = true }) => {
    const isLoyaltyActive = useLoyalty();
    const [isLoaded, setLoaded] = useState(false);
    const [points, setPoints] = useState(0);
    useEffect(() => {
        const user = getUser();
        if (isLoyaltyActive && user.uuid && user.ciam_token) {
            LoyaltyApi.init()
                .getPoints(user.uuid, user.ciam_token)
                .then((response) => {
                setPoints(response.points);
                setLoaded(true);
            })
                .catch((error) => {
                console.error("Error fetching user points:", error);
            });
        }
    }, [isLoyaltyActive]);
    useEffect(() => {
        globalEventsHandler.updateLoyaltyPoints().listen((points) => setPoints(points));
    }, []);
    if (!isLoaded) {
        return null;
    }
    return (_jsxs("div", { className: classNames("pointsDisplay", { "pointsDisplay--styledNumber": isStyledNumber }), "data-testid": "pointsDisplay", children: [_jsx("span", { className: "pointsDisplay__points", "data-testid": "pointsDisplayPoints", children: points }), currency && (_jsx("span", { className: "pointsDisplay__currency", "data-testid": "pointsDisplayCurrency", children: currency }))] }));
};
export default PointsDisplay;
//# sourceMappingURL=PointsDisplay.js.map